import { useEffect, useState } from "react";
import {
  FiChevronDown,
  FiDownload,
  FiEye,
  FiFileMinus,
  FiTrash2,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePermissions } from "../../../../../utils/functions/GetMyPermissions";
import { generateFileURL } from "../../../../../utils/functions/ResourceFunctions";
import { useRemoveFromPayrollMutation } from "../../../../api";
import alertCircle from "../../../assets/alert-circle.svg";
import ClickAwayListener from "../ClickAwayListener";
import Actions from "./Actions.module.css";
import { Modal } from "@mui/material";

import { getMimeTypeAndExtension } from "../../../../../utils/getMimeTypeAndExtension";
import { getBase64File } from "../../../../../utils/functions/fileData";

// import { Box } from "@mui/material";
export function PageActions({ children, actions }) {
  const [open, setOpen] = useState(false);
  const { userPermissions } = usePermissions();

  const ActionSlate = ({ action }) => {
    if (action?.condition === true || action?.condition === undefined) {
      return (
        <button
          key={Math.random() * Math.random()}
          className={Actions?.more_action_button}
          onClick={() => {
            action?.action();
            setOpen(false);
          }}
        >
          {action?.name}
        </button>
      );
    } else return <span key={Math.random() * Math.random()}></span>;
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        // onMouseLeave={() => setOpen(false)}
        className={Actions?.more_options}
      >
        <button onClick={() => setOpen(!open)} className={Actions?.button}>
          <span>Action</span> <FiChevronDown />
        </button>
        {open && (
          <div style={{ top: "45px" }} className={Actions.more_options_modal}>
            {children?.map?.((action) => {
              if (
                !action?.permissions ||
                action?.permissions === "" ||
                userPermissions?.includes(action?.permissions) || // No specific permissions required
                (Array.isArray(action.permissions) && // Check if action.permissions is an array
                  action.permissions.some((permission) =>
                    userPermissions.includes(permission)
                  )) // User has any of the required permissions
              ) {
                return (
                  <ActionSlate
                    action={action}
                    key={Math.random() * Math.random()}
                  />
                );
              }
              return <span key={Math.random() * Math.random()}></span>;
            })}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export function TableActions2({
  rowData,
  children,
  actions,
  url,
  id,
  eyeAction,
  refetcth,
}) {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [onRemovePayroll] = useRemoveFromPayrollMutation();
  const handleRemovePayroll = async () => {
    try {
      const responseData = await onRemovePayroll({
        staffID: rowData?.employeeId,
        batchID: rowData?.payrollBatchId,
      }).unwrap();
      if (responseData) {
        toast.success(responseData?.statusMessage);
        setOpenModal(false);
      }
      return responseData?.responseObject;
    } catch (err) {
      toast.dismiss();
      setOpenModal(false);
      toast.error(err?.response?.data?.statusMessage);
    }
  };
  return (
    <>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div
          onMouseLeave={() => setOpen(false)}
          className={`${Actions?.more_options} ${Actions?.more_options_tables}`}
        >
          <div>
            {url && (
              <button
                onClick={eyeAction}
                className={`${Actions?.button} ${
                  children && Actions?.half_border_left
                }`}
              >
                <FiEye />
              </button>
            )}
            {children && (
              <button
                onClick={() => setOpen(!open)}
                className={`${Actions?.button} ${
                  children && Actions?.half_border_right
                } }`}
              >
                <FiChevronDown />
              </button>
            )}
          </div>
          {open && (
            <div className={Actions.more_options_modal}>
              {children?.map?.((action, idx) => (
                <button
                  key={idx}
                  className={Actions.more_action_button}
                  onClick={() => {
                    setOpenModal(!openModal);
                  }}
                >
                  {action?.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </ClickAwayListener>
      {openModal && (
        <RemovePayrollModal
          data={rowData}
          isOpen={openModal}
          handleModal={setOpenModal}
          handleRemovePayroll={handleRemovePayroll}
        />
      )}
    </>
  );
}

export function TableActions({
  url,
  children,
  className,
  urlParams = {},
}) {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const hasMore = Boolean(children && children?.length > 0);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={`${Actions?.more_options} ${Actions?.more_options_tables} ${className}`}
      >
        <div>
          {url && (
            <button
              onClick={() => navigate(url, urlParams)}
              className={`${Actions?.button} ${
                hasMore && Actions?.half_border_left
              }`}
            >
              <FiEye />
            </button>
          )}
          {hasMore && (
            <button
              onClick={() => setOpen(!open)}
              className={`${Actions?.button} ${
                children && Actions?.half_border_right
              } }`}
            >
              <FiChevronDown />
            </button>
          )}
        </div>
        {open && (
          <div className={Actions.more_options_modal}>
            {children?.map?.((action, idx) => (
              <button
                key={idx}
                className={Actions.more_action_button}
                onClick={() => {
                  setOpen(false);
                  action?.action();
                }}
              >
                {action?.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export function TableActionsWithHide({ children }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={`${Actions?.more_options} ${Actions?.more_options_tables}`}
      >
        <div>
          {children && children.length > 0 && (
            <button
              onClick={() => setOpen(!open)}
              className={`${Actions?.button} ${Actions?.half_border_right}`}
            >
              <FiChevronDown />
            </button>
          )}
        </div>
        {open && (
          <div className={Actions.more_options_modal}>
            {children.map(
              (action, idx) =>
                !action.hidden && (
                  <button
                    key={idx}
                    className={Actions.more_action_button}
                    onClick={() => {
                      setOpen(false);
                      action.action();
                    }}
                  >
                    {action.name}
                  </button>
                )
            )}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export function TableActionsWithHideA({ children, url }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={`${Actions?.more_options} ${Actions?.more_options_tables} `}
      >
        <div>
          {" "}
          {url && (
            <button
              onClick={() => navigate(url)}
              className={`${Actions?.button} ${
                children && Actions?.half_border_left
              }`}
            >
              <FiEye />
            </button>
          )}
          {children && children.length > 0 && (
            <button
              onClick={() => setOpen(!open)}
              className={`${Actions?.button} ${Actions?.half_border_right}`}
            >
              <FiChevronDown />
            </button>
          )}
        </div>
        {open && (
          <div className={Actions.more_options_modal}>
            {children.map(
              (action, idx) =>
                !action.hidden && (
                  <button
                    key={idx}
                    className={Actions.more_action_button}
                    onClick={() => {
                      setOpen(false);
                      action.action();
                    }}
                  >
                    {action.name}
                  </button>
                )
            )}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export function TableActionsWithPermission({
  children,
  actions,
  url,
  permissions,
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Check if actions prop is defined before accessing it
  if (!actions) return null;

  const hasApproveDeclinePermission =
    permissions?.includes("Manager") || permissions?.includes("Director");

  const filteredActions = actions.filter((action) => {
    // Show Approve/Decline only if permission matches
    return (
      hasApproveDeclinePermission &&
      (action.name === "Approve Employee Information" ||
        action.name === "Decline Employee Information")
    );
  });

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={`${Actions?.more_options} ${Actions?.more_options_tables}`}
      >
        <div>
          {url && (
            <button
              onClick={() => navigate(url)}
              className={`${Actions?.button} ${
                children && Actions?.half_border_left
              }`}
            >
              <FiEye />
            </button>
          )}
          {children && (
            <button
              onClick={() => setOpen(!open)}
              className={`${Actions?.button} ${
                children && Actions?.half_border_right
              }`}
            >
              <FiChevronDown />
            </button>
          )}
        </div>
        {open &&
          hasApproveDeclinePermission && ( // Only show dropdown if permissions match
            <div className={Actions.more_options_modal}>
              {filteredActions?.map((action, idx) => (
                <button
                  key={idx}
                  className={Actions.more_action_button}
                  onClick={() => {
                    setOpen(false);
                    action?.action();
                  }}
                >
                  {action?.name}
                </button>
              ))}
            </div>
          )}
      </div>
    </ClickAwayListener>
  );
}

export function TableActionsNew({ actions, url }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={`${Actions?.more_options} ${Actions?.more_options_tables}`}
      >
        <div>
          {url && (
            <button
              onClick={() => navigate(url)}
              className={`${Actions?.button} ${
                actions.length && Actions?.half_border_left
              }`}
            >
              <FiEye />
            </button>
          )}
          {actions.length > 0 && (
            <button
              onClick={() => setOpen(!open)}
              className={`${Actions?.button} ${
                actions.length && Actions?.half_border_right
              }`}
            >
              <FiChevronDown />
            </button>
          )}
        </div>
        {open && (
          <div className={Actions.more_options_modal}>
            {actions.map((action, idx) => (
              <button
                key={idx}
                className={Actions.more_action_button}
                onClick={() => {
                  setOpen(false);
                  action.action(); // Execute the action function
                }}
              >
                {action.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export const TableActionsDownload = ({
  link,
  children,
  fileType,
  actions,
  url, // base64 string from the API
  fileName,
  base64File,
  file, // File object, e.g., from file input
}) => {
  const viewFile = () => {
    try {
      let blobUrl;
      if (base64File) {
        const dataUrl = getBase64File(base64File);
        const mimeType = dataUrl.split(";")[0].split(":")[1];
        // Decode Base64 string
        const byteCharacters = atob(base64File);
        const byteNumbers = new Uint8Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        // Create a Blob object
        const blob = new Blob([byteNumbers], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        // Open the file in a new tab
        window.open(blobUrl, "_blank");
      }
      if (file) {
        // If a File object is provided, create a URL for it directly
        blobUrl = window.URL.createObjectURL(file);
      } else if (link) {
        blobUrl = `https://${link}`;
      } else if (url) {
        console.log("url", url);
        // If a base64 string is provided, decode it and create a Blob
        const byteCharacters = atob(url);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Determine the MIME type based on the fileType
        let mimeType;
        switch (fileType.toLowerCase()) {
          case ".pdf":
            mimeType = "application/pdf";
            break;
          case ".jpg":
          case ".jpeg":
            mimeType = "image/jpeg";
            break;
          case ".png":
            mimeType = "image/png";
            break;
          case ".gif":
            mimeType = "image/gif";
            break;
          case ".bmp":
            mimeType = "image/bmp";
            break;
          case ".tiff":
          case ".tif":
            mimeType = "image/tiff";
            break;
          case ".txt":
            mimeType = "text/plain";
            break;
          case ".csv":
            mimeType = "text/csv";
            break;
          case ".doc":
          case ".docx":
            mimeType = "application/msword";
            break;
          case ".xls":
          case ".xlsx":
            mimeType = "application/vnd.ms-excel";
            break;
          case ".ppt":
          case ".pptx":
            mimeType = "application/vnd.ms-powerpoint";
            break;
          case ".mp4":
            mimeType = "video/mp4";
            break;
          case ".mp3":
            mimeType = "audio/mpeg";
            break;
          case ".wav":
            mimeType = "audio/wav";
            break;
          case ".ogg":
            mimeType = "audio/ogg";
            break;
          case ".webm":
            mimeType = "video/webm";
            break;
          case ".zip":
            mimeType = "application/zip";
            break;
          case ".json":
            mimeType = "application/json";
            break;
          case ".xml":
            mimeType = "application/xml";
            break;
          case ".html":
          case ".htm":
            mimeType = "text/html";
            break;
          // Add more cases for other file types as needed
          default:
            console.error("Unsupported file type");
            return;
        }

        // Create a Blob object from the byte array
        const blob = new Blob([byteArray], { type: mimeType });

        // Create a URL for the Blob
        blobUrl = window.URL.createObjectURL(blob);
      } else {
        console.error("No file or URL provided");
        return;
      }

      // Open the file in a new tab
      window.open(blobUrl);

      // Clean up the blob URL after it's used
      return () => {
        window.URL.revokeObjectURL(blobUrl);
      };
    } catch (error) {
      console.error("Error decoding or rendering the file:", error);
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <button
        type="button"
        style={{ padding: "0.57rem", borderRadius: "0px 4px 4px 0px" }}
        onClick={viewFile}
        className={Actions?.button}
      >
        <FiEye />
      </button>
      {actions && (
        <button
          type="button"
          style={{ padding: "0.57rem", borderRadius: "0px 4px 4px 0px" }}
          onClick={() => actions?.()}
          className={`${Actions?.button}`}
        >
          <FiTrash2 />
        </button>
      )}
    </div>
  );
};

export function TableActionsDownloadWithPopup({
  children,
  actions,
  url,
  file,
}) {
  const [open, setOpen] = useState(false);

  const generateFileURL = (file) => {
    // Logic to generate file URL
    return "generated-url";
  };

  const handlePopupOpen = () => {
    setOpen(true);
  };

  const handlePopupClose = () => {
    setOpen(false);
  };

  const handleActionClick = () => {
    // Handle action click
    if (actions) {
      actions();
    }
  };

  const fileURL = !url ? generateFileURL(file) : "";

  return (
    <div className="table-actions-download">
      <button
        type="button"
        onClick={handlePopupOpen}
        className="download-button"
      >
        Download
      </button>

      {open && (
        <div className="popup">
          <div className="popup-content">
            <a href={fileURL || url} target="_blank" rel="noopener noreferrer">
              <button
                type="button"
                onClick={handleActionClick}
                className="popup-button"
              >
                <FiEye />
              </button>
            </a>
            {actions && (
              <button
                type="button"
                onClick={handleActionClick}
                className="popup-button"
              >
                <FiFileMinus />
              </button>
            )}
          </div>
          <button onClick={handlePopupClose} className="close-button">
            Close
          </button>
        </div>
      )}
    </div>
  );
}

export function EditTableActionsDownload({ children, actions, url }) {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  // console.log(url);

  return (
    <div
      onMouseLeave={() => setOpen(false)}
      className={`${Actions?.more_options} ${Actions?.more_options_tables}`}
    >
      <div>
        <button
          type={"button"}
          style={{
            padding: "0.57rem",
            borderRadius: "4px 0px 0px 4px",
            backgroundColor: "#6E9170",
          }}
          onClick={() => navigate(url)}
          className={Actions?.button}
        >
          <FiEye />
        </button>
        <button
          type={"button"}
          style={{ padding: "0.57rem", borderRadius: "0px 4px 4px 0px" }}
          onClick={() => navigate(url)}
          className={`${Actions?.button} }`}
        >
          <FiDownload />
        </button>
      </div>
    </div>
  );
}

const RemovePayrollModal = ({
  data,
  isOpen,
  handleModal,
  handleRemovePayroll,
}) => {
  return (
    <div>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center items-center">
          <div className="bg-[#FFFFFF] w-[500px] p-[24px] mt-[10%] rounded-[12px]">
            <div className="flex justify-center items-center mb-5">
              <div className="bg-[#FEF3F2] p-2 rounded-full">
                <div className="bg-[#FEE4E2] p-2 rounded-full">
                  <img src={alertCircle} alt="" />
                </div>
              </div>
            </div>
            <div className="mb-5">
              <h3 className="text-[18px] font-[500] text-center">
                Remove Staff
              </h3>
            </div>
            <div className="mb-5">
              <p className="text-center text-[#4B664C]">
                Are you sure you want to remove this staff from payroll? This
                action cannot be undone.
              </p>
            </div>
            <div className="flex justify-between">
              <div>
                <button
                  onClick={() => handleModal(!isOpen)}
                  className="py-[10px] px-[18px] border-[#344054] shadow-md border rounded-[8px] w-[120px]"
                >
                  Cancel
                </button>
              </div>
              <div>
                <button
                  onClick={handleRemovePayroll}
                  className="bg-[#D92D20] py-[10px] px-[18px] text-white rounded-[8px] w-[120px]"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
